import { IMAGES } from "@/lib/site";

const Dining = () => (
  <section id="dining" className="py-24 bg-sand-50" data-testid="dining-section">
    <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <div className="aspect-[4/3] rounded-3xl overflow-hidden relative">
        <img
          src={IMAGES.dining}
          alt="Pool deck and beachside restaurant at Raffiel Nias overlooking the ocean at sunset"
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute bottom-6 left-6 right-6 p-4 rounded-xl bg-sand-50/90 backdrop-blur border border-sand-200">
          <p className="text-xs font-mono-clean text-ocean-700 uppercase font-semibold">
            Open Daily 7:00 AM – 10:00 PM
          </p>
          <p className="text-sm font-display font-bold text-ocean-900 mt-1">
            Beachside Restaurant & Rooftop Café
          </p>
        </div>
      </div>
      <div>
        <span className="text-xs font-mono-clean text-ocean-700 uppercase tracking-wider font-semibold">
          Fresh Local Kitchen
        </span>
        <h2 className="font-display text-3xl sm:text-4xl font-bold text-ocean-900 mt-2">
          Fuel up between swells
        </h2>
        <p className="text-sm text-fog mt-4 leading-relaxed">
          Our kitchen serves fresh morning smoothie bowls, robust Indonesian mie
          and nasi goreng, grilled catch-of-the-day fish, Italian pastas, and
          barista coffee on the rooftop overlooking the wave.
        </p>
        <div className="mt-8 grid grid-cols-2 gap-4">
          <div className="p-4 rounded-xl bg-white border border-sand-200">
            <h4 className="font-display font-bold text-sm text-ocean-900">Rooftop Sunset Views</h4>
            <p className="text-xs text-fog mt-1">Panoramic vistas of every set rolling through Lagundri Bay.</p>
          </div>
          <div className="p-4 rounded-xl bg-white border border-sand-200">
            <h4 className="font-display font-bold text-sm text-ocean-900">Clean Fuel Menu</h4>
            <p className="text-xs text-fog mt-1">High-protein meals and vegan options for athletic recovery.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Dining;
